export default function fileNameDownloadHelper(response) {
    const disposition = response.request.getResponseHeader('Content-Disposition');
    if (disposition && disposition.indexOf('attachment') !== -1) {
        var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        var matches = filenameRegex.exec(disposition);
        if (matches != null && matches[1]) { 
          return matches[1].replace(/['"]/g, '');
          }
    }
    return "Download.pdf"; 
}

  